<template>
    <!--   营销管理－商品购买赠送管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this, 'giftManageIndex')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="活动名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="活动时间">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY-MM-DD"
                            v-decorator="['selectDate']"
                            @change="search"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div>
                <a-spin :spinning="spinning">
                    <a-card
                    :bordered="false"
                    :tabList="tabListNoTitle"
                    :activeTabKey="noTitleKey"
                    @tabChange="key => onTabChange(key,'noTitleKey')"
                    v-show="tabKey === '1'"
                    >
                        <div slot="tabBarExtraContent">
                            <a-button type="primary" v-if="getBtnByAuth('addActiveGoods')" @click="showAddActive">新增活动票券</a-button>
                        </div>
                        <div class="active-ticket-list">
                            <template v-for="(item,index) in dataSource">
                                <div class="active-ticket-item" :key="item.ticketGiveId">
                                    <div class="pic mb8" :style="`background-image: url('${item.coverUrl}?x-oss-process=image/resize,w_368/quality,q_80');background-size: cover;`">
                                    </div>
                                    <div class="ml8 mr8">
                                        <a-row>
                                            <a-col span="12">
                                                <div class="title">
                                                    <a-tooltip>
                                                        <template slot="title">
                                                        {{item.name}}
                                                        </template>
                                                        {{item.name}}
                                                    </a-tooltip>
                                                </div>
                                            </a-col>
                                        </a-row>
                                        <div class="info font-small">
                                            <div>活动期间：{{item.startTime}} - {{item.endTime}}</div>
                                            <div>活动期间售卖数/张(不含退款):{{item.sellNum || 0}}<span v-if="getBtnByAuth('watchSellRecord')"><a class="text-primary float-right" @click="toSellDetail(item.ticketGiveId)">查看明细</a></span></div>
                                        </div>
                                    </div>
                                    <a-divider style="margin-top: 8px; margin-bottom: 8px;"></a-divider>
                                    <div class="actions pl8 pr8 pb8">
                                        <a-row>
                                            <a-col span="12">
                                                <a class="text-primary" v-if="getBtnByAuth('watchActiveDetail')" @click="getActiveDetail(item.ticketGiveId)">赠品及规则查看</a>
                                            </a-col>
                                            <a-col span="12" class="text-right">
                                                <template v-if="getBtnByAuth('editActiveGoods')">
                                                    <a class="text-primary" v-if="item.state === 0" @click="showActiveEdit(item)">编辑</a>
                                                    <span class="text-gray" v-else>编辑</span>
                                                </template>
                                                <template v-if="getBtnByAuth('activeGoodsState')">
                                                    <a-divider type="vertical"></a-divider>
                                                    <a class="text-primary" @click="showChangeActiveState(item)">{{item.state === 1 ? '下架' : '上架'}}</a>
                                                    <!-- <span class="text-gray" v-else>{{item.state === 1 ? '下架' : '上架'}}</span> -->
                                                </template>
                                                <template v-if="getBtnByAuth('delActiveGoods')">
                                                    <a-divider type="vertical"></a-divider>
                                                    <a class="text-primary" v-if="item.state === 0" @click="showDelActive(item)">删除</a>
                                                    <span class="text-gray" v-else>删除</span>
                                                </template>
                                            </a-col>
                                        </a-row>
                                    </div>
                                </div>
                            </template>
                            <a-pagination
                                style="width: 100%; text-align: right"
                                :current="pagination.current"
                                :showTotal="pagination.showTotal"
                                :pageSize="pagination.pageSize"
                                :total="pagination.total"
                                @change="changePage"
                            ></a-pagination>
                        </div>
                        <div v-if="dataSource.length === 0">
                            <a-empty />
                        </div>
                    </a-card>
                </a-spin>
            </div>
        </content-view>
        <!-- 新增活动赠送商品及规格配置弹窗 -->
        <a-modal
        :visible="addActiveVisible"
        :title="`${Boolean(currentItem.ticketGiveId) ? '编辑' : '新增'}活动${typeString1(tabKey)}赠送商品及规格配置`"
        :width="1020"
        @cancel="hideAddActive"
        @ok="addActive"
        :destroyOnClose="true"
        :selfUpdate="true"
        class="gift"
        >
            <div class="add-active-container">
                <a-spin :spinning="editSpinning">
                    <a-form :form="addForm" layout="inline">
                        <div class="mb16" v-show="tabKey !== '1'">
                            <a-form-item label="请选择门店">
                                <a-select :options="relShopList" style="width: 400px;margin-left: 28px;" placeholder="请选择" v-decorator="['shopId',{rules: [{required: tabKey !== '1', message: '请选择'}]}]"></a-select>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="活动名称">
                                <a-input style="width: 280px;" placeholder="请输入" v-decorator="[`name`,{rules: [{required: true, message: '请输入'}]}]"></a-input>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <span class="mb16" style="color: #999;">{{typeString1(tabKey)}}选择：</span>
                            <a class="text-primary ml8" @click="openTicketSelect('ticket')">添加{{typeString1(tabKey)}}</a>
                        </div>
                        <div>
                            <template v-for="(item,index) in goodsList">
                                <div class="mb16" v-if="!item.isDel" :key="index">
                                    <a-form-item label="票券">
                                        <section class="flex">
                                            <div class="gooods-length">{{item.label}}</div>
                                            <a-input class="hideInput" disabled v-decorator="[`ticketId[${index}]`, {initialValue: item.ticketId, rules: [{required: true, message: '请选择'}]}]"></a-input>
                                        </section>
                                    </a-form-item>
                                    <a-form-item label="库存">
                                        <a-radio-group :options="createLimit" v-decorator="[`isNumberLimit[${index}]`,{initialValue: item.isNumberLimit, rules: [{required: true}]}]"></a-radio-group>
                                    </a-form-item>
                                    <a-form-item label="" v-show="addForm.getFieldValue(`isNumberLimit[${index}]`)">
                                        <a-input-number @change="changeGiftNum(item, $event, 1, index)" style="width: 240px;" :min="1" :max="9999999" placeholder="请输入" v-decorator="[`number[${index}]`,{initialValue: item.number, rules: [{required: addForm.getFieldValue(`isNumberLimit[${index}]`), message: '请输入'},{validator: validatorRules}]}]"></a-input-number>
                                    </a-form-item>
                                    <a-form-item label="展示价">
                                        <a-input-number :precision="2" style="width: 90px;" :min="0" placeholder="请输入" v-decorator="[`showPrice[${index}]`,{initialValue: item.showPrice, rules: [{required: true, message: '请输入'}]}]" ></a-input-number>
                                    </a-form-item>
                                    <a-form-item label="售卖价">
                                        <a-input-number :precision="2" style="width: 90px;" :min="0" placeholder="请输入" v-decorator="[`sellPrice[${index}]`,{initialValue: item.sellPrice, rules: [{required: true, message: '请输入'}]}]"></a-input-number>
                                    </a-form-item>
                                    <a class="text-primary ml16" style="line-height: 36px;" @click="goodsListDel(index)">删除</a>
                                </div>
                                <div class="mb24" :key="item.ticketTemplateId" v-if="item.sellLimit >= 0 && !item.isDel && isEdit">已使用：{{item.sellLimit}}</div>
                            </template>
                        </div>
                        <div class="mb16">
                            <span style="color: #999;">赠品选择：</span>
                            <a class="text-primary ml8" @click="openTicketSelect('both')">添加赠品</a>
                        </div>
                        <div>
                            <template v-for="(item, index) in giftList">
                                <div class="mb16" v-if="!item.isDel" :key="index">
                                    <a-form-item label="赠品类型">
                                        <section class="flex">
                                            <div class="giftType">{{goodsType[item.goodsType]}}</div>
                                            <a-input class="hideInput" disabled v-decorator="[`type[${index}]`, {initialValue: item.goodsType, rules: [{required: true, message: '请选择'}]}]"></a-input>
                                        </section>
                                    </a-form-item>
                                    <a-form-item label="赠品选择">
                                        <section class="flex">
                                            <div class="gooods-length">{{item.label}}</div>
                                            <a-input class="hideInput" disabled v-decorator="[`giveId[${index}]`, {initialValue: item.giveId, rules: [{required: true, message: '请选择'}]}]"></a-input>
                                        </section>
                                    </a-form-item>
                                    <a-form-item label="赠送数量">
                                        <a-input-number style="width: 80px;" :min="0" placeholder="请输入" v-decorator="[`gNumber[${index}]`,{initialValue: item.number, rules: [{required: true, message: '请输入'}]}]"></a-input-number>
                                    </a-form-item>
                                    <a-form-item label="设置赠品总数">
                                        <a-radio-group :options="createLimit" v-decorator="[`isNumberLimit1[${index}]`,{initialValue: item.isNumberLimit}]"></a-radio-group>
                                    </a-form-item>
                                    <a-form-item label="" v-show="addForm.getFieldValue(`isNumberLimit1[${index}]`)">
                                        <a-input-number :min="1" @change="changeGiftNum(item, $event, 2, index)" :max="9999999"  style="width: 240px;" placeholder="请输入" v-decorator="[`numberNum[${index}]`,{initialValue: item.numberNum, rules: [{required: addForm.getFieldValue(`isNumberLimit1[${index}]`), message: '请输入'},{validator: validatorRules}]}]"></a-input-number>
                                    </a-form-item>
                                    <a class="text-primary ml16" style="line-height: 36px;" @click="giftDel(index)">删除</a>
                                </div>
                                <div class="mb24" :key="item.giveId" v-if="item.sellLimit >= 0 && !item.isDel && isEdit">已使用：{{item.sellLimit}}</div>
                            </template>
                        </div>
                        <div class="mb16" style="color: #999;">积分赠送：</div>
                        <div class="mb16">
                            <a-form-item label="积分类型">
                                <a-select :options="pointTypeOptions" style="width: 200px;" placeholder="请选择" v-decorator="['pointType',{initialValue: 1, rules: [{required: true, message: '请选择'}]}]"></a-select>
                            </a-form-item>
                            <a-form-item label="填写购买可得固定积分" v-show="addForm.getFieldValue('pointType') === 2">
                                <a-input-number :min="0" style="width: 200px;" placeholder="请填写大于0的数字" v-decorator="['pointNum',{rules: [{required: addForm.getFieldValue('pointType') === 2, message: '请填写'}]}]"></a-input-number>
                            </a-form-item>
                            <a-form-item label="填写倍数" v-show="addForm.getFieldValue('pointType') === 3">
                                <a-input-number :min="0" style="width: 200px;" placeholder="请填写大于0的数字" v-decorator="['pointMultiple',{rules: [{required: addForm.getFieldValue('pointType') === 3, message: '请填写'}, {pattern: /^\d{1,8}(\.\d{1,2})?$/, message: '请输入大于0，且保留两位小数'}]}]"></a-input-number>
                            </a-form-item>
                        </div>
                        <div class="mb16" style="color: #999;">规则配置：</div>
                        <div class="mb16">
                            <a-form-item label="赠送规则" :required="true">
                                <div class="mb16">
                                    <a-radio :checked="giveRuleState === 1" @click="giveRuleState = 1">固定赠送规则</a-radio>
                                    <a-form-item :required="false" v-show="giveRuleState === 1">
                                        <a-select :options="giveRuleOptions" style="width: 450px;" placeholder="请选择" v-decorator="['giveRule',{initialValue: 1, rules: [{required: giveRuleState === 1, message: '请选择'}]}]"></a-select>
                                    </a-form-item>
                                </div>
                                <div>
                                    <a-radio :checked="giveRuleState === 2" @click="giveRuleState = 2">自定义赠送规则</a-radio>
                                    <a-form-item :required="false" v-show="giveRuleState === 2">
                                        <span class="mr8">用户前</span>
                                        <a-input-number :min="0" style="width: 150px;" placeholder="仅可填入> 0的整数" v-decorator="['giveRuleCustom',{rules: [{required: giveRuleState === 2, message: '请选择'}]}]"></a-input-number>
                                        <span class="ml8">次购买可活动赠送赠品；（在活动期间内前x次购买{{typeString1(tabKey)}}获得赠品以及赠送积分）</span>
                                    </a-form-item>
                                </div>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="购买规则" :required="true">
                                <a-form-item :label="`单用户在活动期间内，可进行该活动${typeString1(tabKey)}购买次数`" :required="false">
                                    <a-radio-group :options="countLimitOptions" @change="setFieldValue('addForm', 'buyNumber', undefined)" v-decorator="['buyNumberState',{initialValue: countLimitOptions[1].value}]"></a-radio-group>
                                </a-form-item>
                                <a-form-item label="限制次数为" :required="false">
                                    <a-input-number :min="0" placeholder="请输入" :disabled="addForm.getFieldValue('buyNumberState') === 0" style="width: 100px" v-decorator="['buyNumber',{rules: [{required: addForm.getFieldValue('buyNumberState') === 1, message: '请输入'}]}]"></a-input-number>
                                </a-form-item>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-alert message="用户在小程序上的实际购买限制以此为准，建议该限制次数与主票「购买限制张数」保持一致" type="info"></a-alert>
                        </div>
                        <div class="mb16" style="color: #999;">活动上架期间设置：</div>
                        <div class="mb16">
                            <a-form-item label="活动期间" :required="true">
                                <a-range-picker :showTime="{format: 'HH:mm'}" format="YYYY-MM-DD HH:mm" v-decorator="['activeDate', {rules: [{required: true ,message: '请选择'}]}]" />
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="活动备注">
                                <a-textarea style="width:600px;resize: none;" rows="4" placeholder="200字以内" v-decorator="['remark', {rules: [{required: true ,message: '请选择'}]}]" />
                            </a-form-item>
                        </div>
                        <div class="mb16" style="color: #999;">活动展示设置：</div>
                        <div class="mb16">
                            <a-form-item label="是否在小程序上提前展示" :required="true" >
                                <a-radio-group
                                    name="procedureShow"
                                    v-decorator="['procedureShow',{initialValue:0,rules: [{required: true, message: '请选择'}]}]"
                                    >
                                        <a-radio :value="0">否</a-radio>
                                        <a-radio :value="1">是</a-radio>
                                    </a-radio-group>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="活动倒计时是否展示" :required="true">
                                <a-radio-group
                                name="countDownShow"
                                v-decorator="['countDownShow',{initialValue:0,rules: [{required: true, message: '请选择'}]}]"
                                >
                                    <a-radio :value="0">否</a-radio>
                                    <a-radio :value="1">是</a-radio>
                                </a-radio-group>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="剩余库存是否展示" :required="true" :span="12" >
                                <a-radio-group
                                    name="surplusInventoryShow"
                                    v-decorator="['surplusInventoryShow',{initialValue:0,rules: [{required: true, message: '请选择'}]}]"
                                    @change="appletShowChange"
                                    >
                                        <a-radio :value="0">否</a-radio>
                                        <a-radio :value="1">是</a-radio>
                                    </a-radio-group>
                            </a-form-item>
                            <a-form-item :span="12" v-if="appletShow" >
                                当库存剩余为 <a-input-number :min="1" :max="999"  v-decorator="['inventoryNumShow',{rules: [{required: true, message: '请输入'}]}]" @change="changeInventoryNum"></a-input-number> 时，在小程序开始展示
                            </a-form-item>
                        </div>
                    </a-form>
                </a-spin>
            </div>
        </a-modal>
        <!-- 新增活动赠品及规则查看 -->
        <a-modal
        :visible="activeDetailVisible"
        :title="`活动${typeString1(tabKey)}赠品及规则查看`"
        :width="930"
        @cancel="activeDetailVisible = false"
        >
            <a-spin :spinning="detailSpinning">
                <div>
                    <a-form layout="inline">
                        <div>
                            <a-form-item :label="`活动名称`" :required="true">
                                {{activeDetail.name}}
                            </a-form-item>
                        </div>
                        <div class="mb16 mt16" style="color: #999;">票券：</div>
                        <template v-for="(item) in activeDetail.ticketGiveTicketVos || []">
                            <div class="mb16" :key="item.id">
                                <a-form-item label="票券" :required="true">
                                    <div style="width: 260px; white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">id:{{item.ticketId}}; 票名：{{item.name || item.ticketName}};</div>
                                </a-form-item>
                                <a-form-item label="库存">
                                    <div style="width: 80px;">{{item.number == "9999999" ? "不限量" : item.number}}</div>
                                </a-form-item>
                                <a-form-item label="展示价">
                                    <div style="width: 90px;">{{item.showPrice}}</div>
                                </a-form-item>
                                <a-form-item label="售卖价">
                                    <div style="width: 90px;">{{item.sellPrice}}</div>
                                </a-form-item>
                            </div>
                        </template>
                        <div class="mb16 mt16" style="color: #999;">赠品：</div>
                        <template v-for="(item) in activeDetail.gifts">
                            <div class="mb16" :key="item.id">
                                <a-form-item label="赠品类型" :required="true">
                                    <div style="width: 60px;">{{goodsType[item.type]}}</div>
                                </a-form-item>
                                <a-form-item label="赠品名称" :required="true">
                                    <div style="width: 160px; white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                                        <a-tooltip>
                                            <template slot="title">
                                            {{item.name}}
                                            </template>
                                            id：{{item.giveId}}; {{item.type == 1 ? '票名：' : '优惠券名：'}}{{item.name || item.ticketName}};
                                        </a-tooltip>
                                    </div>
                                </a-form-item>
                                <a-form-item label="赠送数量" :required="true">
                                    <div style="width: 80px;">{{item.number}}</div>
                                </a-form-item>
                                <a-form-item label="活动赠品总数" :required="true">
                                    <div style="width: 120px;">{{item.numberNum == "9999999" ? '不限数量' : item.numberNum}}</div>
                                </a-form-item>
                            </div>
                        </template>
                        <div class="mb16" style="color: #999;">积分赠送：</div>
                        <div class="mb16">
                            <a-form-item label="积分类型" :required="true">
                                {{pointTypeOptions[activeDetail.pointType - 1].label}}
                            </a-form-item>
                            <a-form-item label="填写购买可得固定积分" :required="true" v-if="activeDetail.pointType === 2">
                                {{activeDetail.pointNum}}
                            </a-form-item>
                            <a-form-item label="倍数" :required="true" v-if="activeDetail.pointType === 3">
                                {{activeDetail.pointMultiple}}
                            </a-form-item>
                        </div>
                        <div class="mb16" style="color: #999;">活动规则：</div>
                        <div class="mb16">
                            <a-form-item label="赠送规则" :required="true">
                                <a-form-item :required="false" v-if="activeDetail.giveRuleState === 1">
                                    {{giveRuleOptions[activeDetail.giveRule - 1].label}}
                                </a-form-item>
                                <a-form-item :required="false" v-if="activeDetail.giveRuleState === 2">
                                    <span class="mr8">用户前</span>
                                    {{activeDetail.giveRuleCustom}}
                                    <span class="ml8">次购买可活动赠送赠品；（在活动期间内前x次购买{{typeString1(tabKey)}}获得赠品以及赠送积分）</span>
                                </a-form-item>
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="购买规则" :required="true">
                                <a-form-item :required="false">
                                    {{`单用户在活动期间内，可进行该活动${typeString1(tabKey)}购买次数：`}}
                                    <template v-if="activeDetail.buyNumberState === 0">
                                        不限数量
                                    </template>
                                    <template v-else-if="activeDetail.buyNumberState === 1">
                                        {{activeDetail.buyNumber}}次
                                    </template>
                                </a-form-item>
                            </a-form-item>
                        </div>
                        <div class="mb16" style="color: #999;">活动上架期间设置：</div>
                        <div class="mb16">
                            <a-form-item label="活动期间" :required="true">
                                {{activeDetail.startTime}} <span class="ml16 mr16">至</span> {{activeDetail.endTime}}
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="活动备注">
                                {{activeDetail.remark}}
                            </a-form-item>
                        </div>
                        <div class="mb16" style="color: #999;">活动展示设置：</div>
                        <div class="mb16">
                            <a-form-item label="是否在小程序上提前展示" :required="true">
                                {{activeDetail.procedureShow ? '是' : '否'}}
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="活动倒计时是否展示" :required="true">
                                {{activeDetail.countDownShow ? '是' : '否'}}
                            </a-form-item>
                        </div>
                        <div class="mb16">
                            <a-form-item label="剩余库存是否展示" :required="true">
                                {{activeDetail.surplusInventoryShow ? '是' : '否'}};
                            </a-form-item>
                            <a-form-item v-if="activeDetail.surplusInventoryShow">
                                当库存剩余为 {{activeDetail.inventoryNumShow}} 时，在小程序开始展示
                            </a-form-item>
                        </div>
                        <div class="mb16">

                        </div>
                    </a-form>
                </div>
            </a-spin>
            <template slot="footer">
                <div class="text-center">
                    <a-button @click="activeDetailVisible = false">返回</a-button>
                </div>
            </template>
        </a-modal>
        <!-- 上下架 -->
        <a-modal
        :visible="stateActiveVisible"
        :title="`${currentItem.state === 1 ? '下架确认' : '上架确认'}`"
        :width="450"
        centered
        @cancel="stateActiveVisible = false"
        >
            <div class="text-center">
                确认将该活动票券进行{{`${currentItem.state === 1 ? '下架' : '上架'}`}}操作？
                <br>
                {{currentItem.state === 1 ? '下架确认' : '上架确认'}}后，用户通过小程序购买该票券将{{currentItem.state === 1 ? '不再' : ''}}获得对应赠品
            </div>
            <template slot="footer">
                <div class="text-center">
                    <a-button @click="stateActiveVisible = false">取消{{currentItem.state === 1 ? '下架' : '上架'}}</a-button>
                    <a-button @click="changeActiveState" :loading="confirmLoading" style="margin-left: 80px" type="primary">确认{{currentItem.state === 1 ? '下架' : '上架'}}</a-button>
                </div>
            </template>
        </a-modal>
        <!-- 删除活动弹窗 -->
        <a-modal
        :visible="delActiveVisible"
        title="确认删除"
        :width="450"
        centered
        @cancel="delActiveVisible = false"
        >
            <div class="text-center">
                确认将该活动票券进行删除操作？
                <br>
                删除后，后台将不再展示该活动票券配置信息
            </div>
            <template slot="footer">
                <div class="text-center">
                    <a-button @click="delActiveVisible = false">取消删除</a-button>
                    <a-button @click="delActive" :loading="confirmLoading" style="margin-left: 80px" type="primary">确认删除</a-button>
                </div>
            </template>
        </a-modal>
        <ticket-picker :goodType="selectGoodType" ref="ticketPicker" :ticketList="ticketList" :couponList="couponList" @confirmSelectTicket='confirmSelectTicket'></ticket-picker>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from "moment";
    import ticketPicker from "@/components/modules/platform/tickets-picker.component"
    import { mapGetters } from "vuex";
    const LOAD_NUM = 50;
    const tabListNoTitle = [
        {
            key: '1',
            tab: '活动中'
        },
        {
            key: '2',
            tab: '活动未开始'
        },
        {
            key: '3',
            tab: '活动已结束'
        }
    ]
    const countTypeOptions = [
        {
            label: '不限数量',
            value: 0
        },
        {
            label: '数量限制',
            value: 1
        }
    ]
    const createLimit = [
        {
            label: '不限量',
            value: 0
        },
        {
            label: '限量',
            value: 1
        }
    ]
    const goodsType = [
        '','票券','优惠券'
    ]
    const countLimitOptions = [
        {
            label: '不限次数',
            value: 0
        },
        {
            label: '次数限制',
            value: 1
        }
    ]
    const pointTypeOptions = [
        {value: 1,label: '暂不设置'},
        {value: 2,label: '固定积分'},
        {value: 3,label: '本单应得金额倍数'}
    ]
    const giveRuleOptions = [
        {value: 1,label: '首次购买（在活动期间内首次购买票券获得赠品以及赠送积分）'},
        {value: 2,label: '每次购买（在活动期间内每次购买票券获得赠品以及赠送积分）'},
        {value: 3,label: '每日首次购买（活动期间每日首次购买票券获得赠品及赠送积分）'}
    ]
    const giveGoodsTypeOptions2 = [
        {
            value: 1,
            label: '票券',
            children: [
                {
                    value: 1,
                    label: '已上架'
                },
                {
                    value: 2,
                    label: '已下架'
                }
            ]
        },
        {
            value: 2,
            label: '优惠券',
            children: [
                {
                    value: 1,
                    label: '门票优惠券'
                },
                {
                    value: 2,
                    label: '餐饮优惠券'
                },
                {
                    value: 3,
                    label: '零售优惠券'
                },
                {
                    value: 4,
                    label: '课程优惠券'
                },
                {
                    value: 10,
                    label: '租赁优惠券'
                },
            ]
        },
        {
            value: 3,
            label: '储值卡',
            children: [
                {
                    value: 1,
                    label: '储值卡'
                }
            ]
        },
    ]
    const giveGoodsTypeOptions = [
        {
            value: 1,
            label: '票券',
            children: [
                {
                    value: 1,
                    label: '已上架'
                },
                {
                    value: 2,
                    label: '已下架'
                }
            ]
        },
        {
            value: 2,
            label: '优惠券',
            children: [
                {
                    value: 1,
                    label: '门票优惠券'
                },
                {
                    value: 2,
                    label: '餐饮优惠券'
                },
                {
                    value: 3,
                    label: '零售优惠券'
                },
                {
                    value: 4,
                    label: '课程优惠券'
                },
                {
                    value: 10,
                    label: '租赁优惠券'
                },
            ]
        },
        // {
        //     value: 3,
        //     label: '储值卡',
        //     children: [
        //         {
        //             value: 1,
        //             label: '储值卡'
        //         }
        //     ]
        // },
    ]
    export default {
        name: "giftManageIndex",
        components: {
            ticketPicker,
        },
        props: {},
        data() {
            return {
                spinning: false,
                confirmLoading: false,
                editSpinning: false,
                detailSpinning: false,
                shopList: [],
                relShopList: [],
                dataSource: [],
                tabListNoTitle: tabListNoTitle,
                noTitleKey: '1',
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                selectGoodType: "ticket",
                createLimit,
                goodsType,
                countTypeOptions,
                giveRuleState: 2,
                countLimitOptions,
                pointTypeOptions,
                giveRuleOptions,
                giveGoodsTypeOptions2,
                tabKey: '1',
                addActiveVisible: false,
                stateActiveVisible: false,
                delActiveVisible: false,
                activeDetailVisible: false,
                giftList: [],
                goodsList: [],
                currentItem: {},
                activeDetail: {
                    pointType: 1,
                    gifts: [],
                },
                appletShow: false,
                ticketList: [],
                couponList: [],
                isEdit: false,
                giftDetail: {},
            };
        },
        filters: {
        },
        computed: {
            ...mapGetters(["shopId"]),
            validGiftList() {
                return this.giftList.filter(item => !item.isDel);
            },
            validGoodsList() {
                return this.goodsList.filter(item => !item.isDel);
            },
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "activeIndex") {
                    this.getList();
                }
            },
            'shopId'(val) {
                this.form.resetFields();
                if (val !== -1) {
                    this.relShopList = this.shopList.filter(item => item.id === val);
                } else {
                    this.relShopList = this.shopList;
                }
                this.getList();
                this.getShopList();
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.addForm = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            if (this.shopId !== -1) {
                this.relShopList = this.shopList.filter(item => item.id === this.shopId);
            } else {
                this.relShopList = this.shopList;
            }
            this.getShopList();
            this.getTicket();
            this.getCoupon()
            this.getList();
        },
        methods: {
            openTicketSelect(type) {
                this.selectGoodType = type;
                this.$refs.ticketPicker.visible = true;
            },
            confirmSelectTicket(ticket) {
                if (this.selectGoodType === 'both') {
                    let giftList = [];
                    ticket.forEach( el => {
                        giftList.push({
                            giveId: el.giveId,
                            name: el.name,
                            label: el.label,
                            showName: el.showName,
                            number: undefined,
                            numberNum: undefined,
                            goodsType: el.goodsType,
                            ticketGiveId: undefined,
                            type: el.type || el.suitType,
                            isNumberLimit: 0,
                            sellLimit: 0,
                            options: [],
                            isDel: false
                        })
                    })
                    this.giftList = [...this.giftList, ...giftList];
                    return;
                }
                let goodsList = [];
                ticket.forEach( el => {
                    goodsList.push({
                        coverUrl: el.coverUrl,
                        id: undefined,
                        number: undefined,
                        showName: el.showName,
                        ticketGiveId: undefined,
                        ticketId: el.ticketTemplateId,
                        ticketType: el.type,
                        ticketName: el.name,
                        name: el.name,
                        label: el.label,
                        sellLimit: 0,
                        isNumberLimit: 0,
                        isDel: false
                    })
                })
                this.goodsList = [...this.goodsList, ...goodsList];
            },
            // 时间选择
            moment,
            typeString1(val) {
                return val === '1' || val === '2' ? '票券' : '课程';
            },
            handleReset() {
                this.form.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.current = page;
                this.getList();
            },
            onTabChange(noTitleKey,keyName) {
                this[keyName] = noTitleKey;
                this.pagination.current = 1;
                this.getList();
            },
            changeInventoryNum(e){
                if(e > 999){
                    return this.$message.error("剩余库存大于999不可设置在小程序上显示",1)
                }
            },
            appletShowChange(e) {
                this.appletShow = Boolean(e.target.value)
            },
            changeGiftNum(item, event, type, index) {
                this.giftDetail = {};
                this.giftDetail = item;
            },
            // TODO
            validatorRules(rule, value, callback){
                if (rule.fullField.indexOf("numberNum") > -1) {
                    let index = rule.fullField.match(/\d/) ? rule.fullField.match(/\d/)[0] : undefined;
                    var sellLimit = this.giftList[index].sellLimit;
                    var ticketGiveId = this.giftList[index].ticketGiveId || undefined;
                } else if (rule.fullField.indexOf("number") > -1) {
                    let index = rule.fullField.match(/\d/) ? rule.fullField.match(/\d/)[0] : undefined;
                    var sellLimit = this.goodsList[index].sellLimit;
                    var ticketGiveId = this.goodsList[index].ticketGiveId || undefined;
                }
                if (!this.isEdit) {
                    callback();
                    return;
                }
                if ((!value && value != 0) || !ticketGiveId) {
                    callback();
                    return;
                }
                if (value && sellLimit > value) {
                    callback('总库存数不能小于已使用数量 ' + sellLimit)
                } else {
                    callback();
                }
            },
            /**
             * @showAddActive 显示新增活动弹窗
             */
            showAddActive() {
                this.isEdit = false;
                this.currentItem = {};
                this.addActiveVisible = true;
                this.editSpinning = false;
            },
            /**
             * @hideAddActive 隐藏新增活动弹窗
             */
            hideAddActive() {
                this.addActiveVisible = false;
                this.appletShow = false;
                this.giveRuleState = 2;
                setTimeout(() => {
                    this.giftList = [];
                    this.goodsList = []
                }, 500);
            },
            /**
             * @setFieldValue 设置值
             */
            setFieldValue(form, key, val) {
                let obj = {};
                obj[key] = val;
                this[form].setFieldsValue(obj);
            },
            /**
             * @giftDel 删除活动票券
             */
            goodsListDel(key) {
                this.goodsList[key].isDel = true;
                if (this.goodsList[key].hasOwnProperty('id')) {
                    this.goodsList[key].isDel = 1;
                }
            },
            /**
             * @giftDel 删除活动赠品
             */
            giftDel(key) {
                this.giftList[key].isDel = true;
                if (this.giftList[key].hasOwnProperty('id')) {
                    this.giftList[key].isDel = 1;
                }
            },
            /**
             * @addActive 新增活动
             */
            addActive() {
                if (!this.goodsList.length) {
                    this.$message.warning("请先选择主票");
                    return;
                }
                if (!this.giftList.length) {
                    this.$message.warning("请先选择赠品");
                    return;
                }
                this.addForm.validateFields((errors, values) => {
                    if (!Boolean(errors)) {
                        //giftAddDTOS 赠送商品的列表
                        let giftAddDTOS = [];
                        let ticketGiveTicketDTOS = [];
                        values.giveId.forEach((item, index) => {
                            let curItem = this.giftList[index];
                            var {giveId, showName, name} = curItem;
                            let obj = {
                                giveId: giveId,
                                name: name,
                                showName: showName,
                                type: values.type[index],
                                number: values.gNumber[index],
                                isNumberLimit: values.isNumberLimit1[index],
                                numberNum: values.isNumberLimit1[index] == 1 ? values.numberNum[index] : "9999999",
                            };
                            if (values.type[index][0] == 3) {
                                obj.balanceAmount = amount;
                            }
                            if (curItem.hasOwnProperty('id')) {
                                obj.id = curItem.id;
                                obj.ticketGiveId = curItem.ticketGiveId;
                                obj.isDel = curItem.isDel;
                            }
                            giftAddDTOS.push(obj);
                        });
                        values.ticketId.forEach((item, index) => {
                            let curItem = this.goodsList[index];
                            let ticketDetail = this.ticketList.find( el => item === el.ticketTemplateId);
                            let obj = {
                                ticketId: item,
                                showName: ticketDetail.showName,
                                coverUrl: ticketDetail.coverUrl || curItem.coverUrl,
                                ticketType: ticketDetail.ticketType,
                                ticketName: ticketDetail.name,
                                number: values.isNumberLimit[index] == 1 ? values.number[index] : "9999999",
                                isNumberLimit: values.isNumberLimit[index],
                                sellPrice: values.sellPrice[index],
                                showPrice: values.showPrice[index],
                            }
                            if (curItem.hasOwnProperty('id')) {
                                obj.id = curItem.id;
                                obj.ticketGiveId = curItem.ticketGiveId;
                                obj.isDel = curItem.isDel;
                            }
                            ticketGiveTicketDTOS.push(obj);
                        })

                        values.ticketGiveId = this.currentItem.ticketGiveId;
                        values.giftAddDTOS = giftAddDTOS;
                        values.ticketGiveTicketDTOS = ticketGiveTicketDTOS;
                        values.startTime = values.activeDate[0].format('YYYY-MM-DD HH:mm:00');
                        values.endTime = values.activeDate[1].format('YYYY-MM-DD HH:mm:00');
                        values.giveRuleState = this.giveRuleState;
                        if (values.shopId) {
                            values.shopName = this.relShopList.find(item => Number(item.id) === Number(values.shopId)).name;
                        }
                        delete values.giveId;
                        delete values.gNumber;
                        delete values.numberNum;
                        delete values.activeDate;
                        delete values.type;
                        delete values.isNumberLimit1;

                        delete values.ticketId;
                        delete values.showPrice;
                        delete values.number;
                        delete values.type;
                        delete values.isNumberLimit;
                        delete values.sellPrice;
                        if (values.giveRuleState === 1) {
                            delete values.giveRuleCustom;
                        } else if (values.giveRuleState === 2) {
                            delete values.giveRule;
                        }
                        const ticketGive = this.isEdit ? "editTicketGive" : "addTicketGive";
                        this.$api.changeCode[ticketGive]({
                            body: {
                                ...values,
                                type: this.tabKey,
                                shopId: this.shopId,
                                coverUrl: ticketGiveTicketDTOS[0].coverUrl,
                                operatorId: this.userInfo.id,
                                operator: this.userInfo.name
                            }
                        }).then(res => {
                            this.appletShow = false;
                            this.hideAddActive();
                            this.getList();
                        }).catch(err => {
                        });
                    }
                });
            },
            //获取列表
            getList() {
                if(!this.shopId) return;
                this.spinning = true;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    if (values.selectDate) {
                        values.startTime = values.selectDate.length > 0 ? values.selectDate[0].format('YYYY-MM-DD') : undefined;
                        values.endTime = values.selectDate.length > 0 ? values.selectDate[1].format('YYYY-MM-DD') : undefined;
                        delete values.selectDate;
                    }
                    values.activityState = this.noTitleKey;

                    if(Number(this.shopId) !== -1) {
                        values.shopId = this.shopId;
                    }
                    this.$api.changeCode.ticketGiveList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.spinning = false;
                        if (values.activityState == 1) {
                            this.dataSource = res.list.filter(el => el.state == 1);
                        } else {
                            this.dataSource = res.list;
                        }

                        this.$set(this.pagination, "total", Number(res.total));
                    });
                });
            },
            /**
             * @getShopList 获取门店列表
             */
            getShopList() {
                if (!Boolean(this.shopId)) {
                    return false;
                }
                this.$api.totalPlatform.selectList().then(res => {
                    res.forEach((item,index) => {
                        item.label = item.name;
                        item.value = item.id;
                    });
                    this.shopList = res;
                    if (Number(this.shopId) !== -1) {
                        this.relShopList = this.shopList.filter(item => Number(item.id) === Number(this.shopId));
                    } else {
                        this.relShopList = this.shopList;
                    }
                });
            },
            /**
             * @getTicket 获取票列表
             */
            getTicket() {
                this.$api.totalPlatform.getTotalTicketList({}).then(res => {
                    res.forEach((item, index) => {
                        item.label = "id：" + item.ticketTemplateId + "; 票名：" + item.name;
                        item.value = item.ticketTemplateId;
                        item.giveId = item.ticketTemplateId;
                        item.goodsType = 1;
                    });
                    this.ticketList = res;
                });
            },
            getCoupon() {
                this.$api.changeCode.queryNewCoupon().then(res => {
                    res.forEach((item, index) => {
                        item.label = "id：" + item.id + "; 优惠券名：" + item.name;
                        item.value = item.id;
                        item.giveId = item.id;
                        item.goodsType = 2;
                    });
                    this.couponList = res;
                });
            },
            /**
             * @showActiveEdit 显示编辑弹窗
             */
            showActiveEdit(item) {
                this.currentItem = item;
                this.isEdit = true;
                this.addActiveVisible = true;
                this.editSpinning = true;
                this.$api.changeCode.showGive({
                    params: {id: item.ticketGiveId}
                }).then(res => {
                    this.editSpinning = false;
                    this.giveRuleState = res.giveRuleState;
                    // 票列表
                    if (Boolean(res.ticketGiveTicketVos)) {
                        res.ticketGiveTicketVos.forEach(item => {
                            item.number = item.number == -1 ? "9999999" : item.number;
                            item.isDel = false;
                            item.label = "id：" + item.ticketId + "; 票名：" + item.ticketName;
                            item.isNumberLimit = !item.isNumberLimit || item.number == "9999999" ? 0 : 1;
                            item.type = item.type;
                            item.goodsType = item.type;
                            item.sellLimit = item.totalSellNum + item.lockNum;
                        })
                        this.goodsList = res.ticketGiveTicketVos;
                    }
                    if (Boolean(res.gifts)) {
                        res.gifts.forEach((item, index) => {
                            item.numberNum = item.numberNum == -1 ? "9999999" : item.numberNum;
                            item.options = [];
                            if (item.type === 1) {
                                item.label = "id：" + item.giveId + "; 票名：" + item.name;
                            } else {
                                item.label = "id：" + item.giveId + "; 优惠券名：" + item.name;
                            }
                            item.sellLimit = item.totalSellNum + item.lockNum;
                            item.isDel = false;
                            item.type = item.type;
                            item.goodsType = item.type;
                            item.isNumberLimit = !item.isNumberLimit || item.numberNum == "9999999" ? 0 : 1;
                        });
                        this.giftList = res.gifts;
                    }
                    let {
                        name,
                        buyNumber,
                        buyNumberState,
                        giveRule,
                        giveRuleCustom,
                        number,
                        numberState,
                        pointMultiple,
                        pointNum,
                        pointType,
                        price,
                        remark,
                        showPrice,
                        ticketId,
                        shopId,
                        startTime,
                        endTime,
                        procedureShow,
                        countDownShow,
                        surplusInventoryShow,
                        inventoryNumShow
                    } = res;
                    let reWriteData = {
                        buyNumberState,
                        number,
                        numberState,
                        pointType,
                        price,
                        remark,
                        showPrice,
                        ticketId: String(ticketId),
                        activeDate: [this.$moment(startTime), this.$moment(endTime)],
                        procedureShow,
                        countDownShow,
                        surplusInventoryShow,
                        inventoryNumShow,
                        name
                    }
                    this.appletShow = Boolean(surplusInventoryShow)
                    //赠品赠送规则
                    if (res.giveRuleState === 1) {
                        reWriteData.giveRule = giveRule;
                    } else if (res.giveRuleState === 2) {
                        reWriteData.giveRuleCustom = giveRuleCustom;
                    }
                    //赠送活动商品总数量
                    if (res.buyNumberState === 1) {
                        reWriteData.buyNumber = buyNumber;
                    }
                    //赠送积分规则
                    if (res.pointType === 2) {
                        reWriteData.pointNum = pointNum;
                    } else if (res.pointType === 3) {
                        reWriteData.pointMultiple = pointMultiple;
                    }
                    //是否有关联门店
                    if (res.shopId !== null) {
                        reWriteData.shopId = shopId;
                    }
                    this.$nextTick(() =>{
                        this.addForm.setFieldsValue(reWriteData);
                    })

                });
            },
            /**
             * @showChangeActiveState 显示改变上下架弹窗
             */
            showChangeActiveState(item) {
                this.currentItem = item;
                this.stateActiveVisible = true;
            },
            /**
             * @changeActiveState 改变上下架状态
             */
            changeActiveState() {
                let {ticketGiveId,state} = this.currentItem;
                this.confirmLoading = true;
                this.$api.changeCode.state({
                    body: {
                        id: ticketGiveId,
                        state: state === 1 ? 0 : 1,
                        operatorId: this.userInfo.id,
                        operator: this.userInfo.name
                    }
                }).then(res => {
                    this.stateActiveVisible = false;
                    this.confirmLoading = false;
                    setTimeout(() => {
                        this.getList();
                    }, 500);
                }).catch(err => {
                    this.confirmLoading = false;
                    this.stateActiveVisible = false;
                });
            },
            /**
             * @showDelActive 显示改变删除活动弹窗
             */
            showDelActive(item) {
                this.currentItem = item;
                this.delActiveVisible = true;
            },
            /**
             * @delActive 删除活动
             */
            delActive() {
                let {ticketGiveId} = this.currentItem;
                this.confirmLoading = true;
                this.$api.changeCode.delInfo({
                    body: {
                        ticketGiveId,
                        operatorId: this.userInfo.id,
                        operator: this.userInfo.name
                    }
                }).then(res => {
                    this.delActiveVisible = false;
                    this.confirmLoading = false;
                    this.getList();
                }).catch(err => {
                    this.delActiveVisible = false;
                    this.confirmLoading = false;
                });
            },
            /**
             * @getActiveDetail 获取活动详情
             */
            getActiveDetail(id) {
                this.activeDetailVisible = true;
                this.detailSpinning = true;
                this.$api.changeCode.showGive({
                    params: {
                        id
                    }
                }).then(res => {
                    this.activeDetail = res;
                    this.detailSpinning = false;
                });
            },
            /**
             * @toSellDetail 点击查看详情
             */
            toSellDetail(id) {
                if (!id) return;
                this.$router.push({name: 'giveActiveSellDetail', params: {id}});
            }
        }
    };
</script>
<style lang="scss">
    .gift {
        .giftType {
            width: 60px;
        }
        .gooods-length {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .hideInput {
            visibility: hidden;
            width: 0;
            height: 0;
            overflow: hidden;
            padding: 0;
            border: none
        }
    }

    .container {
        background: #fff;
    }
    .active-ticket-list {
        display: flex;
        flex-wrap: wrap;
        .text-gray {
            color: #bbb;
            cursor: not-allowed;
        }
        .active-ticket-item {
            width: 368px;
            margin: 0 32px 32px 0;
            border: 1px solid #ddd;
            word-break: break-all;
            .pic {
                width:100%;
                height: 185px;
                background-size: 100% 100%;
                position: relative;
                .shopName {
                    width: 100%;
                    padding: 4px 8px;
                    position: absolute;
                    bottom: 0;
                    background-color: #f5a14191;
                    color: #fff;
                }
            }
            .title {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 18px;
                padding-top: 8px;
            }
            .info {
                color: #999;
            }
        }
    }
    .add-active-container {
        .ant-form-inline .ant-form-item-with-help {
            margin-bottom: 0px;
        }
        .ant-form-explain {
            position: absolute;
        }
    }
</style>
